export default {
    baseUrl: null,

    setBaseUrl (url) {
        if(url && url.length > 0){
            const curLocation = window.location;
            const base = curLocation.protocol+'//'+curLocation.hostname;
            if(curLocation.port == '8080' && url.indexOf(':8080/') !== -1){
                // this is development env running in local mode
                console.log('this is development env running in local mode');
                url = process.env.VUE_APP_DEV_STORE;
            }
            const oUrl = new URL(url, base);
            const path = oUrl.pathname.split("/");

            this.baseUrl = oUrl.origin + "/" + path[1] + "/" + path[2];
        }
    },

    getUrl (controllerAction) {
        //console.log('get URL for ', controllerAction)
        if(this.baseUrl === null) {
            //console.log('set base URL from ', window.location.href);
            // parse base URL from current location
            this.setBaseUrl(window.location.href);
        }
        let url = this.baseUrl;
        if(typeof controllerAction !== 'undefined'){
            url = url + "/" + controllerAction;
        }
        return url;
    },
}    